<template>
    <form @submit.prevent="handleSubmit" id="location_edit_form">
        <div class="mb-4">
            <label class="form-label form-label-thin">
                Location Name <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name" v-model="form.name"
                placeholder="Enter location name" />
        </div>

        <div class="mb-4">
            <label class="form-label form-label-thin">Description</label>
            <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
                v-model="form.description" rows="3" placeholder="Enter location description"></textarea>
        </div>

        <div class="mb-4">
            <MultiSelect v-model="form.parent_id" :options="parentOptions" :multiple="false" label="Parent Location" name="parent_id" id="parent_id" ref="parent_id"
                placeholder="None (Top Level Location)" />
        </div>

        <div class="mb-4">
            <label class="form-label form-label-thin">Address</label>
            <input type="text" class="form-control form-control-thin" v-model="form.address"
                placeholder="Enter full address" />
        </div>

        <div class="mb-4" v-if="existingImages.length">
            <label class="form-label form-label-thin">
                Existing Images
            </label>

            <div class="row g-2">
                <div class="col-md-3" v-for="(image, index) in existingImages" :key="image.id || index">
                    <div class="position-relative border rounded p-2">
                        <div class="attachment-preview mb-2 rounded d-flex align-items-center justify-content-center"
                            style="width: 100%; height: 80px; background-color: #f0f0f0; overflow: hidden;">
                            <img :src="getFileUrl(image.file_path || image.url)"
                                :alt="image.file_name || 'Location image'"
                                style="max-width: 100%; max-height: 100%; object-fit: cover;" />
                        </div>

                        <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
                            @click="removeExistingImage(index)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4">
            <FileUploader v-model:files="form.image" :help-text="'Upload new images (optional)'" />
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger btn-sm" @click="close">
                <i class="fa fa-times"></i>
                Cancel
            </button>

            <button type="submit" class="btn btn-primary btn-sm" :disabled="submitting">
                <i v-if="!submitting" class="fa fa-save"></i>
                <i v-else class="fa fa-spinner fa-spin"></i>
                {{ submitting ? 'Updating...' : 'Update Location' }}
            </button>
        </div>
    </form>
</template>
<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'
import FileUploader from '@/components/FileUploader.vue'

export default {
    name: 'EditLocation',

    components: {
        MultiSelect,
        FileUploader
    },

    emits: ['updated', 'close'],

    props: {
        location: {
            type: Object,
            required: true
        },
        Parentlocations: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            submitting: false,
            form: {
                id: null,
                name: '',
                description: '',
                parent_id: '',
                address: '',
                image: []
            },
            existingImages: []
        }
    },

    computed: {
        filteredParents() {
            if (!this.form.id) return this.Parentlocations
            return this.Parentlocations.filter(loc => loc.id !== this.form.id)
        },
        parentOptions() {
            return this.filteredParents.map(loc => ({
                id: loc.id,
                name: loc.name
            }))
        }
    },

    watch: {
        location: {
            immediate: true,
            deep: true,
            handler(value) {
                if (!value) return

                this.form.id = value.id
                this.form.name = value.name || ''
                this.form.description = value.description || ''
                this.form.parent_id = value.parent_id || ''
                this.form.address = value.address || ''
                this.form.image = []
                const imageSource = value.attachments || value.images
                this.existingImages = imageSource
                    ? JSON.parse(JSON.stringify(imageSource))
                    : []
            }
        }
    },

    methods: {
        removeExistingImage(index) {
            this.existingImages.splice(index, 1)
        },
        getFileUrl(filePath) {
            if (!filePath) return ''
            if (filePath.startsWith('http')) return filePath
            const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000'
            return `${baseUrl}/${filePath}`
        },
        async handleSubmit() {
            this.submitting = true

            const fd = new FormData()
            fd.append('id', this.form.id)

                ;['name', 'description', 'address'].forEach(key => {
                    if (this.form[key] !== null) {
                        fd.append(key, this.form[key])
                    }
                })

            fd.append('parent_id', this.form.parent_id || '')

            this.existingImages.forEach(img => {
                fd.append('existing_images[]', img.id)
            })

            if (this.form.image && this.form.image.length) {
                this.form.image.forEach(file => {
                    fd.append('image[]', file)
                })
            }

            const result = await form_api_submit({
                url: `locations/update/${this.form.id}`,
                method: 'POST',
                data: fd,
                curr_form_id: '#location_edit_form'
            })

            this.submitting = false

            if (result.success) {
                this.$emit('updated')
            }
        },

        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.text-muted {
    color: #6c757d;
    font-size: 0.75rem;
}

.position-relative img {
    height: 120px;
    width: 100%;
    object-fit: cover;
}

.attachment-preview {
    transition: all 0.2s ease;
}

.attachment-preview:hover {
    border-color: #534AB7;
}

.position-relative {
    position: relative;
}

.btn-danger.position-absolute {
    margin: -5px -5px 0 0;
}
</style>